import moment from "moment";
import type { ColumnTypeFn } from "../types";

export const datetimeType: ColumnTypeFn = (value) => {
  const date = moment(value);
  return <>{date.isValid() ? date.format("DD.MM.YYYY HH:mm:ss") : String(value)}</>;
};
